var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "PortalWidget",
    { attrs: { widget: _vm.widget } },
    [
      _c("div", { staticClass: "m-t-10 m-b-15" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-success btn-sm",
            attrs: {
              type: "button",
              "data-testid": "v2-login-security-revoke-all"
            },
            on: {
              click: function($event) {
                _vm.showConfirmation = true
              }
            }
          },
          [
            _c("i", { staticClass: "fas fa-user-slash" }),
            _vm._v(" "),
            _c("span", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "LOGIN_SECURITY_REVOKE_ALL_TOKENS",
                  expression: "'LOGIN_SECURITY_REVOKE_ALL_TOKENS'"
                }
              ]
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "v-table",
        {
          staticClass: "table_beauty",
          attrs: {
            data: _vm.logEntries,
            "current-page": _vm.currentPage,
            "page-size": 10,
            "hide-sort-icons": true,
            "data-testid": "v2-login-security-table"
          },
          on: {
            "update:currentPage": function($event) {
              _vm.currentPage = $event
            },
            "update:current-page": function($event) {
              _vm.currentPage = $event
            },
            totalPagesChanged: function($event) {
              _vm.totalPages = $event
            }
          },
          scopedSlots: _vm._u([
            {
              key: "body",
              fn: function({ displayData }) {
                return _c(
                  "tbody",
                  {},
                  _vm._l(displayData, function(row) {
                    return _c("tr", { key: row.id }, [
                      _c("td", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.formatDate(row.loginUTC)) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(row.ip))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(row.location))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(row.userAgent))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(_vm.formatLoginType(row)))])
                    ])
                  }),
                  0
                )
              }
            }
          ])
        },
        [
          _c("thead", { attrs: { slot: "head" }, slot: "head" }, [
            _c(
              "tr",
              [
                _c("v-th", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "LOGIN_SECURITY_LOGIN_UTC",
                      expression: "'LOGIN_SECURITY_LOGIN_UTC'"
                    }
                  ],
                  attrs: { "sort-key": "loginUTC" }
                }),
                _vm._v(" "),
                _c("v-th", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "LOGIN_SECURITY_LOGIN_IP",
                      expression: "'LOGIN_SECURITY_LOGIN_IP'"
                    }
                  ],
                  attrs: { "sort-key": "ip" }
                }),
                _vm._v(" "),
                _c("v-th", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "LOGIN_SECURITY_LOCATION",
                      expression: "'LOGIN_SECURITY_LOCATION'"
                    }
                  ],
                  attrs: { "sort-key": "location" }
                }),
                _vm._v(" "),
                _c("v-th", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "LOGIN_SECURITY_USER_AGENT",
                      expression: "'LOGIN_SECURITY_USER_AGENT'"
                    }
                  ],
                  attrs: { "sort-key": "userAgent" }
                }),
                _vm._v(" "),
                _c("v-th", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "LOGIN_SECURITY_LOGIN_TYPE",
                      expression: "'LOGIN_SECURITY_LOGIN_TYPE'"
                    }
                  ],
                  attrs: { "sort-key": "loginType" }
                })
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "pagination-min" }, [
        _c(
          "div",
          { staticClass: "text-center p-7" },
          [
            _c("smart-pagination", {
              attrs: {
                "current-page": _vm.currentPage,
                "total-pages": _vm.totalPages,
                "max-page-links": 10
              },
              on: {
                "update:currentPage": function($event) {
                  _vm.currentPage = $event
                },
                "update:current-page": function($event) {
                  _vm.currentPage = $event
                }
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.getMyLoginHistoryStatus.status === "pending"
        ? _c(
            "div",
            { staticClass: "well well-sm text-center" },
            [
              _c("Loader"),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "LOGIN_SECURITY_TABLE_LOADING",
                    expression: "'LOGIN_SECURITY_TABLE_LOADING'"
                  }
                ]
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.tableEmpty
        ? _c("div", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "LOGIN_SECURITY_TABLE_EMPTY",
                expression: "'LOGIN_SECURITY_TABLE_EMPTY'"
              }
            ],
            staticClass: "well well-sm text-center"
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showConfirmation
        ? _c("ConfirmationModal", {
            attrs: {
              title: _vm.$t("LOGIN_SECURITY_REVOKE_ALL_TOKENS"),
              "show-confirm-button": true,
              "show-header-close-button": true,
              "show-custom-button": false
            },
            on: {
              close: function($event) {
                _vm.showConfirmation = false
              },
              confirm: _vm.onRevokeTokenConfirmed
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }